/**
 * The admin shell — the Studio's top bar, and no rail.
 *
 * Two landmarks: `nav` in the flat bar, `main` for the surface. The Studio's third one (the
 * rail) is a workspace affordance — siblings, state, the compose source — and none of those
 * exist here. What is left is the bar with the wordmark reading *Atlas Nook · admin*, so a
 * tab open beside the Studio is never mistaken for it.
 *
 * `Grain` comes along because it is the paper the design system draws on; leaving it out
 * would make this app a different-looking tool rather than the same tool with fewer parts.
 */

import { Grain } from '@atlas-nook/design-system';
import type { JSX } from 'react';
import { Outlet } from 'react-router';

import { ADMIN_STRINGS as S } from '../strings.js';
import { TopBar } from './TopBar.js';

export function AdminShell(): JSX.Element {
  return (
    <>
      <div className="app">
        <a className="skip" href="#main">
          {S.app.skipToMain}
        </a>
        <TopBar />
        <div className="app-body" data-browse="">
          <main className="surface" id="main" aria-label={S.app.mainLabel}>
            <Outlet />
          </main>
        </div>
      </div>
      <Grain />
    </>
  );
}
